import React from 'react';
import { authenticate } from 'redux-simple-auth';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Session from './Session';
import withQueryParams from './withQueryParams';

class RouteSetToken extends React.Component {

  componentDidMount() {

    const { authenticate, query } = this.props;
    const token = JSON.parse(query.get('token'));

    authenticate('user', token)
      .then(({ type }) => {
        if (type === '@@redux-simple-auth/AUTHENTICATE_FAILED') {
          throw type
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }

  render() {

    const { query } = this.props;

    return (
      <Session
        render={({ authenticated, hasFailedAuth }) =>
          hasFailedAuth || authenticated ? (
            <Redirect to={query.get('return_to') || '/'} />
          ) : null
        }
      />
    )
  }
}

export default compose(
  connect(null, { authenticate }),
  withQueryParams
)(RouteSetToken)



// WEBPACK FOOTER //
// ./src/components/RouteSetToken.js